export const DietMealSize = (json: IDietMealSize): IDietMealSizeModel => {
	const { name, meal_kind, is_active, created_at, updated_at, ...rest } = json

	const short_name = name.replace('Rozmiar', '').trim()

	return {
		name,
		shortName: short_name,
		mealKind: meal_kind,
		isActive: is_active,
		createdAt: created_at,
		updatedAt: updated_at,

		...rest,
	}
}

export const dietMealSizeToJSON = (obj: Partial<IDietMealSizeModel>): Partial<IDietMealSize> => {
	const { mealKind, isActive, createdAt, updatedAt, ...rest } = obj
	return {
		meal_kind: mealKind,
		is_active: isActive,
		created_at: createdAt,
		updated_at: updatedAt,
		...rest,
	}
}
